import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "base-label flex flex-row items-start fill-current" }
const _hoisted_2 = ["for"]
const _hoisted_3 = {
  key: 0,
  class: "input-required ml-1"
}

import { computed, useAttrs } from 'vue'

interface Props {
  /** Display an info icon with a tooltip with the given text */
  info?: string | null
  /** Whether the field is required */
  required?: boolean
}


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'BaseLabel'
},
  __name: 'BaseLabel',
  props: {
    info: { default: null },
    required: { type: Boolean }
  },
  setup(__props: any) {





const attrs = useAttrs()

/**
 * Fetch `for` attribute from passed attributes
 */
const labelFor = computed(() => (attrs.for as string | undefined) ?? null)

return (_ctx: any,_cache: any) => {
  const _component_VIcon = _resolveComponent("VIcon")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      for: labelFor.value,
      class: "input-label flex items-start fill-current select-none"
    }, [
      _renderSlot(_ctx.$slots, "default"),
      (__props.required)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, "*"))
        : _createCommentVNode("", true)
    ], 8, _hoisted_2),
    (__props.info)
      ? _withDirectives((_openBlock(), _createBlock(_component_VIcon, {
          key: 0,
          icon: "$information-outline",
          class: "mb-1 ml-2 inline-block self-center align-middle text-primary focus:outline-hidden",
          size: "small"
        }, null, 512)), [
          [_directive_tooltip, __props.info]
        ])
      : _createCommentVNode("", true)
  ]))
}
}

})